<template>
  <overlay-template
    :title="'Month rate'"
    :primary-number-title="'Minimum'"
    :primary-number="rate.monthRate"
    :primary-number-unit="'/person/client (1/' + rate.goal.clientLoad + ' capacity)'"
    :secondary-number="rate.monthBreakEven"
    :good-for="[
      'Monthly rates map directly with your company’s financial rhythm',
      'In other words, they help you see the anticipated monthly cycle of expenses vs income',
      'They can also be good for presenting monthly contracts like retainers, consulting packages, or maintenance agreements',
      'Goal setting and forecasting'
    ]"
    :not-good-for="[
      'Tracking smaller project tasks and effort',
      'Estimating or scoping short or long term projects'
    ]"
  >
    <div slot="intro">
      <p>Your monthly rate is the amount you charge for one person to do one month of work for one client.</p>
      <p>The trick is to reduce your outgoing expenses and match the rhythm with more regular incoming revenue. This will allow you smooth out your cashflow and do simpler forecasting.</p>
      <p>Aim to reduce your expenses or reduce your team size if you need to focus on improving your monthly revenue to expenses.</p>
    </div>
    <p slot="formula">{{ rate.goal.incoming | currency }} target annual revenue &divide; 12 months &divide; {{ rate.goal.billableEmployees }} billable employees &times; 1/{{ rate.goal.clientLoad }} capacity (client load) = <strong>{{ rate.monthRate | currency }}/month/person/client</strong></p>
    <p slot="break-even-formula">{{ rate.goal.outgoing | currency }} break-even &divide; 12 months &divide; {{ rate.goal.billableEmployees }} billable employees &times; 1/{{ rate.goal.clientLoad }} capacity (client load) = <strong>{{ rate.monthBreakEven | currency }}/month/person/client</strong></p>

    <div
      v-if="rate.monthRate"
      slot="charts"
      class="grid-column-span-3_sm grid-column-span-2_lg">
      <div class="reverse p2 mb4 c1 group">
        <h2>Ballpark estimator</h2>
        <div class="measure left">
          <p>Calculate a high-level estimate for your project based on people needed, duration, and capacity. Then refine your estimate based on a more detailed scope, risks, and the value you can return.</p>
        </div>
        <p class="mb2 align-right">
          <span class="font-size-8 extra-condensed price">{{ months * people * capacity * rate.monthRate | currency }}</span>
          <span
            v-if="rate.monthBreakEven"
            class="font-size-2 bold dark-red-300-text">{{ months * people * capacity * rate.monthBreakEven | currency }}</span>&nbsp;<span class="font-size-1 dark-red-300-text m0 semibold">break even</span><br>
        </p>
        <lw-range-input
          :label="peopleLabel"
          :min="1"
          :max="rate.goal.billableEmployees"
          :step="1"
          :class="'clear mb2'"
          v-model="people"
        />
        <lw-range-input
          :label="'Average ' + Math.round(capacity / rate.goal.clientLoad * 100) + '% allocation to project per person'"
          :min="1"
          :max="rate.goal.clientLoad"
          :class="'mb2'"
          :step="1"
          v-model="capacity"
        />
        <lw-range-input
          :label="months + ' month project'"
          :min="1"
          :max="12"
          :step="1"
          v-model="months"
        />
      </div>
    </div>
  </overlay-template>
</template>

<script>
import OverlayTemplate from './OverlayTemplate.vue'
import RangeInput from '../../livewires/RangeInput.vue'

export default {
  components: {
    overlayTemplate: OverlayTemplate,
    lwRangeInput: RangeInput
  },
  data () {
    return {
      page: this.$route.params.id,
      people: 1,
      months: 1,
      capacity: 1
    }
  },
  computed: {
    rate () {
      return this.$store.getters.rateCard(this.page)
    },
    peopleLabel () {
      const label = this.people > 1 ? ' people' : ' person'
      return 'Average ' + this.people + label + ' on the project'
    }
  }
}
</script>
